import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import Dialog from 'components/Dialog'
import Heading from 'components/Heading'
import constants from 'constants'
import classnames from 'classnames'
import Card from 'components/Card'
import Button from 'components/Button'
// import moment from 'moment'
import { format } from 'date-fns'
import { generateCSV } from 'utils/generateCSV'
import { PartnerPlanOverviewPageList, PartnerPlanUploadLogList } from './components/Admin'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'

const styles = Object.assign(
  {},
  require('./PartnerPlans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class PartnerPlanAdminView extends React.Component {
  static propTypes = {
    bulkUpdatePartnerPlanStatus: PropTypes.func.isRequired,
    createPartnerplanForFY: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    getPartnerPlanUploadLogs: PropTypes.func.isRequired,
    openPartnerPlanOverviewForm: PropTypes.func.isRequired,
    partnerPlanAdmin: PropTypes.object.isRequired,
    setCurrentOverviewPageActive: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props)
    this.state = {
      showNewPlanDialog: false,
      showDraftPlanDialog: false,
      showInterimPlanDialog: false,
      showFinalPlanDialog: false,
      nextFY: (getFiscalYearTimestamps().next.year),
      currentFy: (getFiscalYearTimestamps().current.year),
      selectedMenuAction: '',
      noOfDays: '1',
    }
  }

  handleGetPartnerPlanUploadLogs = (noDays) => {
    this.setState({ noOfDays: noDays })
    this.props.getPartnerPlanUploadLogs(noDays)
  }

  handleOpenDialog = (id) => {
    setTimeout(() => { this.setState({ selectedMenuAction: id }) }, 500)
    if (id === constants.PARTNERPLAN.PHASE.DRAFT) {
      this.setState({ showDraftPlanDialog: true })
    } else if (id === constants.PARTNERPLAN.PHASE.INTERIM_ASSESSMENT) {
      this.setState({ showInterimPlanDialog: true })
    } else if (id === constants.PARTNERPLAN.PHASE.FINAL_ASSESSMENT) {
      this.setState({ showFinalPlanDialog: true })
    } else {
      this.setState({ showNewPlanDialog: true })
    }
  }

  handleCloseDialog = () => {
    if (this.state.selectedMenuAction === constants.PARTNERPLAN.PHASE.DRAFT) {
      this.setState({ showDraftPlanDialog: false })
    } else if (this.state.selectedMenuAction === constants.PARTNERPLAN.PHASE.INTERIM_ASSESSMENT) {
      this.setState({ showInterimPlanDialog: false })
    } else if (this.state.selectedMenuAction === constants.PARTNERPLAN.PHASE.FINAL_ASSESSMENT) {
      this.setState({ showFinalPlanDialog: false })
    } else {
      this.setState({ showNewPlanDialog: false })
    }
  }

  handleSubmitDialog = (param) => {
    switch (this.state.selectedMenuAction) {
      case constants.PARTNERPLAN.PHASE.DRAFT:
        this.props.setCurrentOverviewPageActive(this.props.currentUser.EmployeeId, constants.PARTNERPLAN.PHASE.DRAFT)
        this.setState({ showDraftPlanDialog: false })
        break
      case constants.PARTNERPLAN.PHASE.INTERIM_ASSESSMENT:
        this.props.setCurrentOverviewPageActive(this.props.currentUser.EmployeeId, constants.PARTNERPLAN.PHASE.INTERIM_ASSESSMENT)
        // if (param) {
        this.props.bulkUpdatePartnerPlanStatus(this.state.currentFy, param, constants.PARTNERPLAN.MODIFIED_BY_ADMIN)
        // }
        this.setState({ showInterimPlanDialog: false })
        break
      case constants.PARTNERPLAN.PHASE.FINAL_ASSESSMENT:
        this.props.setCurrentOverviewPageActive(this.props.currentUser.EmployeeId, constants.PARTNERPLAN.PHASE.FINAL_ASSESSMENT)
        // if (param) {
        this.props.bulkUpdatePartnerPlanStatus(this.state.currentFy, param, constants.PARTNERPLAN.MODIFIED_BY_ADMIN)
        // }
        this.setState({ showFinalPlanDialog: false })
        break
      default:
        this.props.createPartnerplanForFY(param)
        this.setState({ showNewPlanDialog: false })
        break
    }
  }

  handleRatingVisibility = () => {
    this.props.history.push('/admin/admincentre/partnerplan/ratingvisibility')
  }

  render() {
    const createNewPlansDialogProps = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        { label: 'CREATE PLANS FOR CURRENT FY', onClick: () => this.handleSubmitDialog(this.state.currentFy) },
        { label: 'CREATE PLANS FOR NEXT FY', onClick: () => this.handleSubmitDialog(this.state.nextFY) },
      ],
      title: 'Create Partner Plans?',
      active: this.state.showNewPlanDialog,
      onClose: this.handleCloseDialog,
    }

    const openPlansToDraftProps = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        { label: 'OPEN PLANS TO DRAFT ASSESSMENT', onClick: this.handleSubmitDialog },
      ],
      title: `Open plans to DRAFT assessment for FY${this.state.currentFy}?`,
      active: this.state.showDraftPlanDialog,
      onClose: this.handleCloseDialog,
    }

    const openPlansToInterimProps = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        // { label: 'PUBLISH OVERVIEW PAGE', onClick: this.handleSubmitDialog },
        { label: 'OPEN PLANS TO INTERIM ASSESSMENT', onClick: () => this.handleSubmitDialog(constants.PARTNERPLAN.PHASE.INTERIM_ASSESSMENT) },
      ],
      title: `Open plans to Interim assessment for FY${this.state.currentFy}?`,
      active: this.state.showInterimPlanDialog,
      onClose: this.handleCloseDialog,
    }

    const openPlansToFinalProps = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        // { label: 'PUBLISH OVERVIEW PAGE', onClick: this.handleSubmitDialog },
        { label: 'OPEN PLANS TO FINAL ASSESSMENT', onClick: () => this.handleSubmitDialog(constants.PARTNERPLAN.PHASE.FINAL_ASSESSMENT) },
      ],
      title: `Open plans to Final assessment for FY${this.state.currentFy}?`,
      active: this.state.showFinalPlanDialog,
      onClose: this.handleCloseDialog,
    }

    const { partnerPlanAdmin, currentUser } = this.props
    if (partnerPlanAdmin.isFetching) {
      return (<Loading pageLoading />)
    }    

    return (
      <div className={styles.content}>
        <section>
          <Heading noTopPadding>Administer partner plan</Heading>
          <Card>
            <div className={classnames(styles.buttonContainer, styles.flexDirection)}>
              <div className={styles.buttonElement1a}>
                <Button className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)} onClick={() => this.handleRatingVisibility()} type="flat" >
                Final Rating Visibility
                </Button>
              </div>
              <div className={styles.buttonElement2}>
                <Button className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)} onClick={() => this.handleOpenDialog('')} type="flat">
                 Create plans for new FY
                </Button>
              </div>
              <div className={styles.buttonElement3} />
              <div className={styles.buttonElement4} />
            </div>
          </Card>
          <Dialog {...createNewPlansDialogProps}>This will create Partner plans for active Partners that does not have a Partner plan record.</Dialog>
        </section>
        <section className={styles.section}>
          {partnerPlanAdmin.fetched &&
          <PartnerPlanOverviewPageList
            bulkUpdatePartnerPlanStatus={this.props.bulkUpdatePartnerPlanStatus}
            createPartnerplanForFY={this.props.createPartnerplanForFY}
            currentUser={currentUser}
            header="Overview page content"
            listItems={partnerPlanAdmin.partnerPlanOverviewPages}
            openPartnerPlanOverviewForm={this.props.openPartnerPlanOverviewForm}
            setCurrentOverviewPageActive={this.props.setCurrentOverviewPageActive}
          />}
        </section>
        <section>
          <Heading noTopPadding>Partner plan stages</Heading>
          <Card>
            <div className={classnames(styles.buttonContainer, styles.flexDirection)}>
              <div className={styles.buttonElement1}>
                <Button className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)} onClick={() => this.handleOpenDialog(constants.PARTNERPLAN.PHASE.DRAFT)} type="flat" >
                Open plans for Draft
              </Button>
              </div>
              <div className={styles.buttonElement2}>
                <Button
                  className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)}
                  onClick={() => this.handleOpenDialog(constants.PARTNERPLAN.PHASE.INTERIM_ASSESSMENT)}
                  type="flat"
                >
                Open plans for Interim assessment
              </Button>
              </div>
              <div className={styles.buttonElement3}>
                <Button
                  className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)}
                  onClick={() => this.handleOpenDialog(constants.PARTNERPLAN.PHASE.FINAL_ASSESSMENT)}
                  type="flat"
                >
                  Open plans for Final assessment
                  </Button>
              </div>
              <div className={styles.buttonElement4} />
            </div>
          </Card>
          <Dialog {...openPlansToDraftProps}>Partner plan overview page will be updated</Dialog>
          <Dialog {...openPlansToInterimProps}>
          Overview page for the interim partner plan will be published, and the partner plan will be opened for interim assessment.</Dialog>
          <Dialog {...openPlansToFinalProps}>
          Overview page for the final partner plan will be published, and the partner plan will be opened for interim assessment.</Dialog>
        </section>
        <section className={styles.section}>
          {partnerPlanAdmin.fetched &&
          <div>
            <PartnerPlanUploadLogList
              currentUser={currentUser}
              getPartnerPlanUploadLogs={this.handleGetPartnerPlanUploadLogs}
              header="Neota Partner plan upload logs"
              listItems={partnerPlanAdmin.partnerPlanUploadLogs}
              noOfDays={this.state.noOfDays}
            />
            <div className={styles.exportPlanLog}>
              <Button
                onClick={() => {
                  generateCSV(constants.PARTNERPLAN.CSVHEADERUPLOADLOG, partnerPlanAdmin.partnerPlanUploadLogs, `partnerplan_uploadlog_report_${format(new Date(), constants.DATE_FORMAT.EXPORT_STANDARD)}`)
                  }}
                type="flat"
              >
                    EXPORT
                  </Button>
            </div>
          </div>
          }
        </section>
      </div>
    )
  }
}

export default PartnerPlanAdminView



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlanAdmin.js